import React, {
  createContext,
  useContext,
  useMemo,
  useState,
  type Dispatch,
  type SetStateAction,
} from "react";

type GeniePanelContextValue = {
  hideScrollFab: boolean;
  setHideScrollFab: Dispatch<SetStateAction<boolean>>;
};

const GeniePanelContext = createContext<GeniePanelContextValue | null>(null);

export function GeniePanelProvider({ children }: { children: React.ReactNode }) {
  const [hideScrollFab, setHideScrollFab] = useState(false);
  const value = useMemo(
    () => ({ hideScrollFab, setHideScrollFab }),
    [hideScrollFab],
  );
  return (
    <GeniePanelContext.Provider value={value}>{children}</GeniePanelContext.Provider>
  );
}

/** When Genie side panel is open or sliding closed, hide floating scroll-to-top so it is not covered or overlapping the chat UI. */
export function useHideScrollFabForGeniePanel(): boolean {
  const ctx = useContext(GeniePanelContext);
  return ctx?.hideScrollFab ?? false;
}

/** Used only by Genie to sync panel open / close animation with scroll FAB visibility. */
export function useGeniePanelScrollFabSync(): Dispatch<SetStateAction<boolean>> {
  const ctx = useContext(GeniePanelContext);
  return ctx?.setHideScrollFab ?? (() => {});
}
